import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { includes, orderBy, filter, reduce } from 'lodash';
import moment from 'moment-timezone';
import ProductSearchA from 'components/ProductSearch/ProductSearchA';
import addSeminarStartAndEndDateBySession from 'utils/Product';
import { displayType, templateType } from './ProductSearchTypes';

/* eslint-disable no-param-reassign */
class ProductSearchContainer extends Component {
  constructor(props) {
    super(props);

    const { items = [] } = props;

    this.originalItems = orderBy(items.map((i) => addSeminarStartAndEndDateBySession(i)),
      ['seminarInfo.start', 'displayName'], ['asc', 'asc']);

    this.state = {
      selectedOptions: [], // Selected checkbox filter options
      pendingOptions: [], // Pending checkbox filter options, for mobile
      searchInput: '', // Class Name Search
      items: this.originalItems,
      itemsShown: this.originalItems.length >= 10 ? 10 : this.originalItems.length,
      showFilters: false,
    };

    // Filter options to choose from
    this.filterOptions = {
      filterLocations: {},
      filterMonths: {},
      filterCreditTypes: {},
      filterCreditHours: {},
      filterTaughtBys: {},
      filterSubjectNames: {},
      filterDeliveryTypes: {},
      filterFormats: {},
    };

    this.pendingFilterOptions = {
      filterLocations: {},
      filterMonths: {},
      filterCreditTypes: {},
      filterCreditHours: {},
      filterTaughtBys: {},
      filterSubjectNames: {},
      filterDeliveryTypes: {},
      filterFormats: {},
    };

    // Holds a list of filter objects to create LiveClassFilterA's
    this.filterDisplays = {
      desktop: {},
      mobile: {},
    };

    // Functions for ProductSearchA
    this.functionOptions = {
      onFilterItems: this.onFilterItems.bind(this),
      onFilterSelect: this.onFilterSelect.bind(this),
      onShowAllItems: this.onShowAllItems.bind(this),
      onClearFilters: this.onClearFilters.bind(this),
      onSearchInput: this.onSearchInput.bind(this),
      onShowFilters: this.onShowFilters.bind(this),
      onCancelFilters: this.onCancelFilters.bind(this),
      onApplyFilters: this.onApplyFilters.bind(this),
      onShowMoreItems: this.onShowMoreItems.bind(this),
      performFiltering: this.performFiltering.bind(this),
    };

    // Load all the checkbox filters
    this.getFilters();

    // Load all filter category objects for LiveClassFilterA
    this.getFilterCategories();
  }

  // List - Show More button
  onShowMoreItems() {
    this.setState((prevState) => ({ itemsShown: prevState.itemsShown + 10 }));
  }

  // Class Names search bar - onInputChange
  onSearchInput = (e) => {
    this.setState({ searchInput: e.target.value }, () => this.performFiltering());
  }

  // Mobile filter window - close
  onCancelFilters() {
    const { selectedOptions = [] } = this.state;
    const { performFiltering } = this.functionOptions;
    this.updateOptions('pendingOptions', selectedOptions, performFiltering);
    this.onShowFilters();
  }

  // Mobile filter window - Select
  onApplyFilters() {
    const { pendingOptions = [] } = this.state;
    const { performFiltering } = this.functionOptions;
    this.updateOptions('selectedOptions', pendingOptions, performFiltering);
    this.onShowFilters();
  }

  // Mobile filter window hide/show
  onShowFilters() {
    const { showFilters } = this.state;
    const { selectedOptions = [] } = this.state;

    if (!showFilters) this.updateOptions('pendingOptions', selectedOptions);

    this.setState({ showFilters: !showFilters });
  }

  // Mobile Filter window - select/deselect options
  onFilterSelect = (property, value) => {
    const { pendingOptions = [] } = this.state;
    const newSelectedOptions = this.updateFilter(pendingOptions, property, value);
    const { performFiltering } = this.functionOptions;

    this.updateOptions('pendingOptions', newSelectedOptions, () => performFiltering(true));
  }

  // Search items with selected filters
  onFilterItems = (property, value) => {
    const { selectedOptions = [] } = this.state;
    const newSelectedOptions = this.updateFilter(selectedOptions, property, value);
    const { performFiltering } = this.functionOptions;

    this.updateOptions('selectedOptions', newSelectedOptions, performFiltering);
  }

  // Clear filters button
  onClearFilters = () => {
    const { showFilters } = this.state;

    // Clear the selectedOptions list and reset the items and itemsShown
    this.setState({
      selectedOptions: [],
      pendingOptions: [],
      searchInput: '',
      items: this.originalItems,
      itemsShown: this.originalItems.length >= 10 ? 10 : this.originalItems.length,
    });

    this.getFilters();
    this.getFilterCategories();

    if (showFilters) this.onShowFilters(); // If mobile popup winow is shown, close it
  }

  // Show All button (only show all from filtered list, not all items)
  onShowAllItems = () => {
    const { items = [] } = this.state; // Get the FILTERED items list
    this.setState({ itemsShown: items.length, items });
  }

  // Generate the list of checkbox filters
  // Generate the list of checkbox filters
  getFilters = (filters = {}, searchInput = '', isPendingFiltering = false) => {
    const reducedFilters = this.calculateLiveCounts(filters, searchInput);

    // This method sorts objects by their key
    const sortObjectKeys = (obj) => Object.keys(obj)
      .sort()
      .reduce((acc, key) => { acc[key] = obj[key]; return acc; }, {});

    const sortObjectMonths = (obj) => Object.keys(obj)
    // This is just to get the int value of the month to compare so we don't need time zone here
      .sort((a, b) => moment().month(a).format('M') - moment().month(b).format('M'))
      .reduce((acc, key) => { acc[key] = obj[key]; return acc; }, {});

    const sortObjectHours = (obj) => Object.keys(obj)
      .sort((a, b) => a.split(' ')[0] - b.split(' ')[0])
      .reduce((acc, key) => { acc[key] = obj[key]; return acc; }, {});

    if (isPendingFiltering) {
      // orderBy sorts the filter options by their key (month is sorted by ordinal)
      this.pendingFilterOptions.filterLocations = sortObjectKeys(reducedFilters.filterLocations);
      this.pendingFilterOptions.filterMonths = sortObjectMonths(reducedFilters.filterMonths);
      this.pendingFilterOptions.filterCreditTypes = sortObjectKeys(reducedFilters.filterCreditTypes);
      this.pendingFilterOptions.filterCreditHours = sortObjectHours(reducedFilters.filterCreditHours);
      this.pendingFilterOptions.filterTaughtBys = sortObjectKeys(reducedFilters.filterTaughtBys);
      this.pendingFilterOptions.filterSubjectNames = sortObjectKeys(reducedFilters.filterSubjectNames);
      this.pendingFilterOptions.filterDeliveryTypes = sortObjectKeys(reducedFilters.filterDeliveryTypes);
      this.pendingFilterOptions.filterFormats = sortObjectKeys(reducedFilters.filterFormats);
    }

    // orderBy sorts the filter options by their key (month is sorted by ordinal)
    this.filterOptions.filterLocations = sortObjectKeys(reducedFilters.filterLocations);
    this.filterOptions.filterMonths = sortObjectMonths(reducedFilters.filterMonths);
    this.filterOptions.filterCreditTypes = sortObjectKeys(reducedFilters.filterCreditTypes);
    this.filterOptions.filterCreditHours = sortObjectHours(reducedFilters.filterCreditHours);
    this.filterOptions.filterTaughtBys = sortObjectKeys(reducedFilters.filterTaughtBys);
    this.filterOptions.filterSubjectNames = sortObjectKeys(reducedFilters.filterSubjectNames);
    this.filterOptions.filterDeliveryTypes = sortObjectKeys(reducedFilters.filterDeliveryTypes);
    this.filterOptions.filterFormats = sortObjectKeys(reducedFilters.filterFormats);
  }

  // Build a mobile and desktop list that will be used in ProductSearchA to build ClassFilterA's
  getFilterCategories(isPendingFiltering = false) {
    const {
      filterLocations,
      filterMonths,
      filterCreditTypes,
      filterCreditHours,
      filterTaughtBys,
      filterSubjectNames,
      filterFormats,
      filterDeliveryTypes,
    } = this.filterOptions;

    const {
      filterLocations: pendingFilterLocations,
      filterMonths: pendingFilterMonths,
      filterCreditTypes: pendingFilterCreditTypes,
      filterCreditHours: pendingFilterCreditHours,
      filterTaughtBys: pendingFilterTaughtBys,
      filterSubjectNames: pendingFilterSubjectNames,
      filterFormats: pendingFilterFormats,
      filterDeliveryTypes: pendingFilterDeliveryTypes,
    } = this.pendingFilterOptions;

    const {
      onFilterItems,
      onFilterSelect,
    } = this.functionOptions;

    const createFilterArray = (filterFunction) => {
      const filterArray = [];

      const createFilter = (title, category, filters) => {
        if (Object.keys(filters).length > 0) {
          filterArray.push({
            title,
            category,
            filters,
            filterFunction,
          });
        }
      };

      const { labelOptions } = this.props;
      const { displayConfiguration, template } = labelOptions;

      createFilter(
        displayConfiguration === displayType.NASBA &&
        (template === templateType.OnlineCourses || template === templateType.LibraryProduct)
          ? 'THEME' : 'SUBJECT',
        'selectedSubjectNames', isPendingFiltering ? pendingFilterSubjectNames : filterSubjectNames,
      );
      createFilter('LOCATION', 'selectedLocations', isPendingFiltering ? pendingFilterLocations : filterLocations);
      createFilter('MONTH', 'selectedMonths', isPendingFiltering ? pendingFilterMonths : filterMonths);
      createFilter(
        displayConfiguration === displayType.NASBA ? 'FIELD OF STUDY' : 'CREDIT TYPE',
        'selectedCreditTypes', isPendingFiltering ? pendingFilterCreditTypes : filterCreditTypes,
      );
      createFilter(
        'CREDIT HOURS', 'selectedCreditHours', isPendingFiltering ? pendingFilterCreditHours : filterCreditHours,
      );
      createFilter('TAUGHT BY', 'selectedTaughtBys', isPendingFiltering ? pendingFilterTaughtBys : filterTaughtBys);
      if (displayConfiguration === displayType.NASBA) {
        createFilter('FORMAT', 'selectedFormats', isPendingFiltering ? pendingFilterFormats : filterFormats);
        createFilter(
          'DELIVERY TYPE',
          'selectedDeliveryTypes',
          isPendingFiltering ? pendingFilterDeliveryTypes : filterDeliveryTypes,
        );
      }

      return filterArray;
    };

    // Create the array of checkbox category groups for both mobile and desktop
    if (!isPendingFiltering) this.filterDisplays.desktop = createFilterArray(onFilterItems);
    this.filterDisplays.mobile = createFilterArray(onFilterSelect);
  }

  updateLiveCountForFilterType = (filtersDict, initialFilters, filterType, selectedType, searchInput = '') => {
    Object.keys(initialFilters[filterType]).map((ch) => {
      // Counts for non selected filters
      let filterObj = { ...filtersDict };
      if (filtersDict[selectedType]) {
        if (!filtersDict[selectedType].includes(ch)) {
          // Counts for non-selected filters
          const tmpFilterObj = { ...filtersDict };
          tmpFilterObj[selectedType] = [...tmpFilterObj[selectedType], ch];
          filterObj = { ...tmpFilterObj };
        }
        // Perform all checkbox filtering, exclude null objects and order by displayName
        let filteredItems = orderBy(this.originalItems.filter((f) => this.filterItem(f, filterObj))
          .map((i) => i), 'displayName', 'asc');
        searchInput = searchInput.toLowerCase();
        // Perform filtering additionally on Class Name dropdown
        filteredItems = filteredItems.filter((i) => (searchInput === ''
          || (i.displayName && i.displayName.toLowerCase().includes(searchInput))
          || (i.description && i.description.toLowerCase().includes(searchInput))));
        if (filteredItems.length === 0) {
          initialFilters[filterType][ch] = 0;
        } else {
          initialFilters[filterType][ch] = this.generateInitialFilters(filteredItems)[filterType][ch];
        }
      }
      return true;
    });
  }

  calculateLiveCounts = (filters = {}, searchInput = '') => {
    const initialFilters = this.generateInitialFilters(this.originalItems); // only to get the keys later
    this.updateLiveCountForFilterType(filters, initialFilters, 'filterMonths', 'selectedMonths', searchInput);
    this.updateLiveCountForFilterType(filters, initialFilters, 'filterCreditTypes', 'selectedCreditTypes', searchInput);
    this.updateLiveCountForFilterType(filters, initialFilters, 'filterTaughtBys', 'selectedTaughtBys', searchInput);
    this.updateLiveCountForFilterType(filters, initialFilters, 'filterLocations', 'selectedLocations', searchInput);
    this.updateLiveCountForFilterType(filters, initialFilters, 'filterCreditHours', 'selectedCreditHours', searchInput);
    this.updateLiveCountForFilterType(
      filters,
      initialFilters,
      'filterSubjectNames',
      'selectedSubjectNames',
      searchInput,
    );
    this.updateLiveCountForFilterType(
      filters, initialFilters, 'filterDeliveryTypes', 'selectedDeliveryTypes', searchInput,
    );
    this.updateLiveCountForFilterType(
      filters, initialFilters, 'filterFormats', 'selectedFormats', searchInput,
    );

    return initialFilters;
  }

  generateInitialFilters = (items = []) => {
    const addItemInfoToFilterCounts = (filters, array, filterKey) => {
      array.map((item) => {
        filters[filterKey] = {
          ...filters[filterKey],
          [item]: (filters[filterKey][item] || 0) + 1,
        };
        return filters;
      });
    };

    // Loop through the items list and extract an object like this
    // filterOptions: { filterLocations: { Onalaska: 6, La Crosse: 3, Holmen: 4 } }
    const reducedFilters = reduce(items, (filters, item) => {
      const {
        city,
        instructor,
        start,
        timeZone,
      } = item.seminarInfo || {};

      if (city) {
        filters.filterLocations = {
          ...filters.filterLocations,
          [city]: (filters.filterLocations[city] || 0) + 1,
        };
      }

      if (instructor) {
        filters.filterTaughtBys = {
          ...filters.filterTaughtBys,
          [instructor]: (filters.filterTaughtBys[instructor] || 0) + 1,
        };
      }

      if (start) {
        const startDate = moment.tz(start, timeZone).format('MMMM');
        filters.filterMonths = {
          ...filters.filterMonths,
          [startDate]: (filters.filterMonths[startDate] || 0) + 1,
        };
      }

      if (item.creditHours) {
        const creditInfoOfItem = reduce(item.creditHours, (creditInfo, ch) => {
          if (!creditInfo.itemCreditType.includes(ch.type)) {
            creditInfo.itemCreditType.push(ch.type);
          }
          if (!creditInfo.itemCreditHours.includes(`${ch.hours.toString()} Hours`)) {
            creditInfo.itemCreditHours.push(`${ch.hours.toString()} Hours`);
          }
          return creditInfo;
        }, {
          itemCreditHours: [],
          itemCreditType: [],
        });

        addItemInfoToFilterCounts(filters, creditInfoOfItem.itemCreditType, 'filterCreditTypes');
        addItemInfoToFilterCounts(filters, creditInfoOfItem.itemCreditHours, 'filterCreditHours');
      }

      if (item.subjects) {
        const subjectsOfItem = reduce(item.subjects, (subjects, sub) => {
          if (!subjects.includes(sub)) {
            subjects.push(sub);
          }
          return subjects;
        }, []);

        addItemInfoToFilterCounts(filters, subjectsOfItem, 'filterSubjectNames');
      }

      if (item.deliveryType) {
        filters.filterDeliveryTypes = {
          ...filters.filterDeliveryTypes,
          [item.deliveryType]: (filters.filterDeliveryTypes[item.deliveryType] || 0) + 1,
        };
      }

      if (item.format) {
        filters.filterFormats = {
          ...filters.filterFormats,
          [item.format]: (filters.filterFormats[item.format] || 0) + 1,
        };
      }

      return filters;
    }, {
      filterLocations: {},
      filterMonths: {},
      filterCreditTypes: {},
      filterCreditHours: {},
      filterTaughtBys: {},
      filterSubjectNames: {},
      filterDeliveryTypes: {},
      filterFormats: {},
    });

    return { ...reducedFilters };
  }

  // Performs filtering after selectedFilters has been updated
  performFiltering = (pending = false) => {
    const { selectedOptions = [], pendingOptions = [] } = this.state;
    let { searchInput = '' } = this.state;

    const getSelectedItemsByCategory = (options, category) => (
      filter(options, (f) => f.type === category).map((i) => i.value)
    );

    // Get the lists of selected items by category for the filterItem function
    const selectedLocations = getSelectedItemsByCategory(selectedOptions, 'selectedLocations');
    const selectedMonths = getSelectedItemsByCategory(selectedOptions, 'selectedMonths');
    const selectedCreditTypes = getSelectedItemsByCategory(selectedOptions, 'selectedCreditTypes');
    const selectedCreditHours = getSelectedItemsByCategory(selectedOptions, 'selectedCreditHours');
    const selectedTaughtBys = getSelectedItemsByCategory(selectedOptions, 'selectedTaughtBys');
    const selectedSubjectNames = getSelectedItemsByCategory(selectedOptions, 'selectedSubjectNames');
    const selectedDeliveryTypes = getSelectedItemsByCategory(selectedOptions, 'selectedDeliveryTypes');
    const selectedFormats = getSelectedItemsByCategory(selectedOptions, 'selectedFormats');

    // Get the lists of selected pending items by category for the filterItem function
    const pendingLocations = getSelectedItemsByCategory(pendingOptions, 'selectedLocations');
    const pendingMonths = getSelectedItemsByCategory(pendingOptions, 'selectedMonths');
    const pendingCreditTypes = getSelectedItemsByCategory(pendingOptions, 'selectedCreditTypes');
    const pendingCreditHours = getSelectedItemsByCategory(pendingOptions, 'selectedCreditHours');
    const pendingTaughtBys = getSelectedItemsByCategory(pendingOptions, 'selectedTaughtBys');
    const pendingSubjectNames = getSelectedItemsByCategory(pendingOptions, 'selectedSubjectNames');
    const pendingDeliveryTypes = getSelectedItemsByCategory(pendingOptions, 'selectedDeliveryTypes');
    const pendingFormats = getSelectedItemsByCategory(pendingOptions, 'selectedFormats');

    const filters = {
      selectedLocations,
      selectedMonths,
      selectedCreditTypes,
      selectedCreditHours,
      selectedTaughtBys,
      selectedSubjectNames,
      selectedDeliveryTypes,
      selectedFormats,
    };

    const pendingFilters = {
      selectedLocations: pendingLocations,
      selectedMonths: pendingMonths,
      selectedCreditTypes: pendingCreditTypes,
      selectedCreditHours: pendingCreditHours,
      selectedTaughtBys: pendingTaughtBys,
      selectedSubjectNames: pendingSubjectNames,
      selectedDeliveryTypes: pendingDeliveryTypes,
      selectedFormats: pendingFormats,
    };

    this.getFilters(pending ? pendingFilters : filters, searchInput, pending);
    this.getFilterCategories(pending);

    // Perform all checkbox filtering, exclude null objects and order by displayName
    let filteredItems = this.originalItems.filter((f) => this.filterItem(f, filters))
      .map((i) => i);

    searchInput = searchInput.toLowerCase();

    // Perform filtering additionally on Class Name dropdown
    filteredItems = filteredItems.filter((i) => (searchInput === ''
      || ((i.displayName && i.displayName.toLowerCase().includes(searchInput))
      || (i.description && i.description.toLowerCase().includes(searchInput)))));

    // Set the new items and reset the itemsShown value
    this.setState({
      items: filteredItems,
      itemsShown: filteredItems.length >= 10 ? 10 : filteredItems.length,
    });
  }

  // Update a single filter selection
  updateFilter = (options = [], property, value) => { // eslint-disable-line class-methods-use-this
    const obj = { type: property, value };
    let newOptions = [...options];

    // Find if current selected option exists
    const optionExists = filter(options, (i) => i.type === property && i.value === value);

    // If not, add it, else remove it
    if (optionExists.length === 0) {
      newOptions.push(obj);
    } else {
      newOptions = filter(newOptions, (i) => (!(i.type === property && i.value === value)));
    }

    return newOptions;
  }

  // This function is used to manage the mobile filter window options between pendingOptions and selectedOptions
  updateOptions = (oldOptions, newOptions, filterFunction) => {
    this.setState({ [oldOptions]: [...newOptions] }, () => filterFunction && filterFunction());
  }

  // Filter an individual item, returns false if no filters are a match
  filterItem = (item, filters) => {
    const {
      selectedLocations,
      selectedMonths,
      selectedCreditTypes,
      selectedCreditHours,
      selectedTaughtBys,
      selectedSubjectNames,
      selectedDeliveryTypes,
      selectedFormats,
    } = filters;

    // If no filters are applied, return true
    if (selectedLocations.length === 0 &&
        selectedMonths.length === 0 &&
        selectedCreditTypes.length === 0 &&
        selectedCreditHours.length === 0 &&
        selectedTaughtBys.length === 0 &&
        selectedSubjectNames.length === 0 &&
        selectedDeliveryTypes.length === 0 &&
        selectedFormats.length === 0) {
      return true;
    }

    let isIncluded = true;

    const {
      city,
      instructor,
      start,
      timeZone,
    } = item.seminarInfo || {};

    // Filter all of the checkbox options
    if (selectedLocations.length > 0 && !includes(selectedLocations, city)) isIncluded = false;

    if (selectedTaughtBys.length > 0 && !includes(selectedTaughtBys, instructor)) isIncluded = false;

    if (selectedCreditTypes.length > 0
      && !item.creditHours.filter((ch) => includes(selectedCreditTypes, ch.type)).length > 0) {
      isIncluded = false;
    }

    if (selectedCreditHours.length > 0
      && !item.creditHours.filter((ch) => includes(selectedCreditHours, `${ch.hours.toString()} Hours`)).length > 0) {
      isIncluded = false;
    }

    if (selectedMonths.length > 0
      && !includes(selectedMonths, moment.tz(start, timeZone).format('MMMM'))) {
      isIncluded = false;
    }

    if (selectedSubjectNames.length > 0
      && (!item.subjects || !item.subjects.filter((sub) => includes(selectedSubjectNames, sub)).length > 0)) {
      isIncluded = false;
    }

    if (selectedDeliveryTypes.length > 0 && !includes(selectedDeliveryTypes, item.deliveryType)) isIncluded = false;

    if (selectedFormats.length > 0 && !includes(selectedFormats, item.format)) isIncluded = false;

    return isIncluded;
  }

  render() {
    const { labelOptions } = this.props;

    return (
      <ProductSearchA
        {...this.state}
        functionOptions={this.functionOptions}
        filterOptions={this.filterOptions}
        filterDisplays={this.filterDisplays}
        labelOptions={labelOptions}
        originalItems={this.originalItems}
      />
    );
  }
}

ProductSearchContainer.propTypes = {
  /**
   * A list of product items
  */
  items: PropTypes.array.isRequired,
  /**
   * Contains filterTitle and mainTitle text
  */
  labelOptions: PropTypes.object.isRequired,
};

export default ProductSearchContainer;
